<template>
  <div id="eventList" class="eventList">
    <div v-if="events.length">
      <div v-for="(event, index) in events" v-bind:key="event.id" @click="showEvent(event)">
        <div class="eventHeader">
          <div v-if="isEventNowOrRecent(event) && (index == 0 || !isEventNowOrRecent(events[Math.max(0, index - 1)]))">
            <div>RECENT</div>
          </div>
          <div v-else-if="isEventUpcoming(event) && (index == 0 || !isEventUpcoming(events[Math.max(0, index - 1)]))">
            <div>UPCOMING</div>
          </div>
        </div>

        <div class="event">
          <div class="cardContainer">
            <div v-if="event.mediaItems && event.mediaItems.length > 0" class="cardMediaBackground">
              <div v-if="event.mediaItems[0].thumbnailLink">
                <img :src="event.mediaItems[0].thumbnailLink" class="cardMedia" />
              </div>
              <div v-else>
                <img :src="event.mediaItems[0].link" class="cardMedia" />
              </div>
            </div>
            <div v-else class="cardMediaBackground_placeholder">
              <img src="../assets/images/LogoCardPlaceholder.png" class="cardMedia_placeholder" />
            </div>

            <div class="cardBottomBackground">
            </div>

            <div class="col0" v-if="isEventChangedForUserInvitation(event, appUser)">
              <div class="statusDot"></div>
            </div>
            <div class="col1">
              <div class="name">{{ event.name }}</div>
              <div class="dateTime">{{ formattedDateTimeString(event.dateTime.toDate(), event.location, appUser.timeZoneIdentifier) }}</div>
              <div class="location" v-if="event.location">{{ event.location.name }} ({{ event.location.cityState }})  <span class="material-symbols-outlined" v-if="event.weatherForecast">{{ googleWeatherSymbolForSfSymbol(event.weatherForecast.forecastSymbolName) }}</span></div>
            </div>

            <div class="col2">
              <p>
                <img v-if="invitationForAppUser(event, appUser).attendanceStatus == 0" src="../assets/images/AttendanceStatusIcon_Unknown.png" class="colorizeAttendanceStatusUnknown" width="44" height="44">
                <img v-if="invitationForAppUser(event, appUser).attendanceStatus == 1" src="../assets/images/AttendanceStatusIcon_In.png" class="colorizeAttendanceStatusAttending" width="44" height="44">
                <img v-if="invitationForAppUser(event, appUser).attendanceStatus == 2" src="../assets/images/AttendanceStatusIcon_InPlusOne.png" class="colorizeAttendanceStatusAttending" width="44" height="44">
                <img v-if="invitationForAppUser(event, appUser).attendanceStatus == 3" src="../assets/images/AttendanceStatusIcon_Out.png" class="colorizeAttendanceStatusNotAttending" width="44" height="44">
                <img v-if="invitationForAppUser(event, appUser).attendanceStatus == 4" src="../assets/images/AttendanceStatusIcon_Undecided.png" class="colorizeAttendanceStatusUndecided" width="44" height="44">
              </p>
              <div style="margin:0.5em 0 0.5em 0">
                <span class="attendanceCountIn"><img src="../assets/images/AttendanceStatusIcon_In.png" class="colorizeAttendanceStatusAttending" width="16" height="16"> {{ eventInvitationAttendanceCount(event, 1) + eventInvitationAttendanceCount(event, 2) * 2 }}</span>
                <span class="attendanceCountOut"><img src="../assets/images/AttendanceStatusIcon_Out.png" class="colorizeAttendanceStatusNotAttending" width="16" height="16"> {{ eventInvitationAttendanceCount(event, 3) }}</span>
                <span class="attendanceCountUndecided"><img src="../assets/images/AttendanceStatusIcon_Undecided.png" class="colorizeAttendanceStatusUndecided" width="16" height="16"> {{ eventInvitationAttendanceCount(event, 0) + eventInvitationAttendanceCount(event, 4) }}</span>
              </div>
            </div>

            <!-- <div class="inactiveBackground">
            </div> -->

            <div v-if="eventCalloutText(event, true) || (event.mediaItems && event.mediaItems.length > 1) || (event.messages && event.messages.length > 0)" :class="eventCalloutContainerStyle(event)">
              <div class="callout">
                <span v-if="eventCalloutText(event, true)" class="calloutFragment">{{ eventCalloutText(event, true).toUpperCase() }}</span>
                <span v-if="eventCalloutText(event, true) && ((event.mediaItems && event.mediaItems.length > 1) || (event.messages && event.messages.length > 0))" class="calloutDivider"></span>
                <span v-if="event.mediaItems && event.mediaItems.length > 1" class="calloutFragment"><img src="../assets/images/CalloutIcon_Multimedia.png" class="colorizeBackground" height="16" /></span>
                <span v-if="event.messages && event.messages.length > 0" class="calloutFragment"><img src="../assets/images/CalloutIcon_Messages.png" class="colorizeBackground" height="16" /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="emptyList">No upcoming events</p>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex"
  import moment from "moment"
  import momentTimeZone from "moment-timezone"
  const fb = require("../firebaseConfig.js")

  export default {
    computed: {
      ...mapState([ "authUser", "appUser", "events", "selectedEvent" ])
    },
    methods: {
      showEvent(event) {
        this.$store.commit('setSelectedEvent', event)
        this.$router.push({ name: 'Event' })
      },
      invitationForAppUser(event, appUser) {
        return this.invitationForPhoneNumber(event, appUser.phoneNumber)
      },
      invitationForPhoneNumber(event, phoneNumber) {
        return event.invitations.find(invitation => invitation.invitee.phoneNumber === phoneNumber)
      },
      isEventChangedForUserInvitation(event, appUser) {
        const invitation = this.invitationForAppUser(event, appUser)

        return (invitation.changes && invitation.changes.length > 0)
      },
    },
    filters: {
      formatDate(val) {
        if (!val) {
          return "-"
        }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          return val
        }
        return `${val.substring(0, 200)}...`
      }
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/EventList.vue